<template>
    <div class="ma-2">
        <v-row>
            <v-col>
                <span class="text-h5">Dashboard geral</span>
            </v-col>
            <v-col cols="12">
                <div class="lighten-3 elevation-4 pa-4">
                    <div class="d-flex align-center">
                        <span>Por padrão o sistema carrega os dados do <b>mês fiscal</b>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                        <v-icon color="primary" size="16">
                                            mdi-help-circle
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>O mês fiscal tem início no primeiro dia do mês<br> e a data final é o dia atual menos três dias.<br> Caso o mês esteja no ínicio, por exemplo o segundo dia do mês,<br> será exibido o mês anterior menos três dias a partir da data atual. </span>
                            </v-tooltip>
                        </span>
                    </div>
                    <div class="d-flex justify-space-between align-center flex-wrap">
                        <v-form ref="form" v-model="valid">
                            <div class="d-flex align-center flex-wrap">
                                <span class="mr-2 grey--text text--darken-3">Data inicial: </span>
                                <v-text-field
                                    class="size-date mr-4"
                                    type="date"
                                    v-model="dateIni"
                                    :rules="[moment(dateIni).format('yyyy/MM/DD') <= moment().format('yyyy/MM/DD') || 'A data inserida não pode ser maior que a data atual', rules.required]"
                                    >
                                </v-text-field>
                                <span class="mr-2 grey--text text--darken-3">Data final: </span>
                                <v-text-field
                                    class="size-date"
                                    v-model="dateEnd"
                                    type="date"
                                    :rules="[moment(dateEnd).format('yyyy/MM/DD') <= moment().format('yyyy/MM/DD') || 'A data inserida não pode ser maior que a data atual', dateIni <= dateEnd || 'A data inical não pode ser maior que a data final', rules.required]">
                                </v-text-field>
                            </div>
                        </v-form>
                        <v-btn
                            :disabled="!valid"
                            color="#1c579a"
                            class="white--text button-primary elevation-2"
                            @click="getData"
                        >
                            <v-progress-circular v-if="loading" :indeterminate="true" size="24"></v-progress-circular>
                            <span v-else >Aplicar Filtros</span>
                        </v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-row>
                    <v-col sm="6" cols="12">
                        <div class="elevation-2 white d-flex justify-space-between pa-4 align-center">
                            <img src="../assets/icons/cards/views.svg" alt="" width="64">
                            <div class="d-flex flex-column align-center">
                                <span class="grey--text text--darken-2 body-2">Visualizações</span>
                                <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!views ? '--' : formatterDecimal.format(views)}}</span>
                            </div>
                        </div>
                    </v-col>
                    <v-col sm="6" cols="12">
                        <div class="elevation-2 white d-flex justify-space-between pa-4 align-center">
                            <img src="../assets/icons/cards/videos.svg" alt="" width="64">
                            <div class="d-flex flex-column align-center">
                                <span class="grey--text text--darken-2 body-2">Publicações</span>
                                <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!uploads ? '--' : formatterDecimal.format(uploads)}}</span>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col sm="6" cols="12">
                        <div class="elevation-2 white d-flex justify-space-between pa-4 align-center">
                            <img src="../assets/icons/cards/rpm-cpm.svg" alt="" width="64">
                            <div class="d-flex flex-column align-center">
                                <span class="grey--text text--darken-2 body-2">Grupos de Assets</span>
                                <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!cms_revenue ? '--' : formatterMoney.format(cms_revenue)}}</span>
                            </div>
                        </div>
                    </v-col>
                    <v-col sm="6" cols="12">
                        <div class="elevation-2 white d-flex justify-space-between pa-4 align-center">
                            <img src="../assets/icons/cards/subscribers.svg" alt="" width="64">
                            <div class="d-flex flex-column align-center">
                                <span class="grey--text text--darken-2 body-2">Inscritos</span>
                                <span class="grey--text text--darken-3 subtitle-1 font-weight-bold">{{!subscribers ? '--' : formatterDecimal.format(subscribers)}}</span>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" md="6">
                 <v-col cols="12">
                    <div class="elevation-2 white pa-4">
                        <div class="border-b pb-1 d-flex justify-space-between align-center">
                            <span class="grey--text text--darken-2 body-1 pointer" @click="activeCat=0">Receita</span>
                            <div class="d-flex">
                                <img src="../assets/icons/cards/cat-green.svg" alt=""  @click="activeCat=1" width="40" v-bind:class="{ active: activeCat == 1 }" class="mr-2 pointer cat-btn">
                                <img src="../assets/icons/cards/cat-yellow.svg" alt=""  @click="activeCat=2" width="40" v-bind:class="{ active: activeCat == 2 }" class="mr-2 pointer cat-btn">
                                <img src="../assets/icons/cards/cat-red.svg" alt=""  @click="activeCat=3" width="40" v-bind:class="{ active: activeCat == 3 }" class="pointer cat-btn">
                            </div>
                        </div>
                        <div class="d-flex justify-space-between align-center mt-3 px-6">
                            <img src="../assets/icons/cards/recepit.svg" alt="" width="64">
                            <div class="d-flex flex-column align-end">
                                <span class="grey--text text--darken-2 body-2 text-center">Receita Bruta</span>
                                <span class="grey--text text--darken-3 subtitle-1 font-weight-bold" v-if="activeCat == 0">
                                    {{ !total_revenue ? '--' : formatterMoney.format(total_revenue) }}
                                </span>
                                <span class="green--text text--darken-3 subtitle-1 font-weight-bold" v-if="activeCat == 1">
                                    {{ !green_revenue ? '--' : formatterMoney.format(green_revenue) }}
                                </span>
                                <span class="yellow--text text--darken-3 subtitle-1 font-weight-bold" v-if="activeCat == 2">
                                    {{ !yellow_revenue ? '--' : formatterMoney.format(yellow_revenue) }}
                                </span>
                                <span class="red--text text--darken-3 subtitle-1 font-weight-bold" v-if="activeCat == 3">
                                    {{ !red_revenue ? '--' : formatterMoney.format(red_revenue) }}
                                </span>
                            </div>
                        </div>
                        <div class="d-flex justify-space-between align-center px-6">
                            <img src="../assets/icons/cards/money-delivery.svg" alt="" width="64">
                            <div class="d-flex flex-column align-end">
                                <span class="grey--text text--darken-2 body-2">Receita Líquida</span>
                                <span class="grey--text text--darken-3 subtitle-1 font-weight-bold" v-if="activeCat == 0">
                                    {{ !net_total_revenue ? '--' : formatterMoney.format(net_total_revenue) }}
                                </span>
                                <span class="green--text text--darken-3 subtitle-1 font-weight-bold" v-if="activeCat == 1">
                                    {{ !net_green_revenue ? '--' : formatterMoney.format(net_green_revenue) }}
                                </span>
                                <span class="yellow--text text--darken-3 subtitle-1 font-weight-bold" v-if="activeCat == 2">
                                    {{ !net_yellow_revenue ? '--' : formatterMoney.format(net_yellow_revenue) }}
                                </span>
                                <span class="red--text text--darken-3 subtitle-1 font-weight-bold" v-if="activeCat == 3">
                                    {{ !net_red_revenue ? '--' : formatterMoney.format(net_red_revenue) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        Top 10 canais com mais visualizações
                    </div>
                    <v-data-table
                        :loading="loading" loading-text="Carregando..."
                        :headers="headers_views"
                        :items="desserts.views"
                        hide-default-footer
                        v-if="desserts.views.length > 0"
                        >
                        <template v-slot:item.value="{ item }">
                            <span>{{formatterDecimal.format(item.value)}}</span>
                        </template>
                    </v-data-table>
                    <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                        <img src="../assets/empty/empty-cms.svg" alt="">
                        <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                        <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                            Não há dados a serem exibidos com este filtro!
                        </span>
                    </div>
                </div>
            </v-col>
            <v-col cols="12">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        Top 10 canais com mais inscrições
                    </div>
                    <v-data-table
                        :loading="loading" loading-text="Carregando..."
                        :headers="headers_subscribers"
                        :items="desserts.subscribers"
                        hide-default-footer
                        v-if="desserts.subscribers.length > 0"
                        >
                        <template v-slot:item.value="{ item }">
                            <span>{{formatterDecimal.format(item.value)}}</span>
                        </template>
                    </v-data-table>
                    <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                        <img src="../assets/empty/empty-cms.svg" alt="">
                        <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                        <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                            Não há dados a serem exibidos com este filtro!
                        </span>
                    </div>
                </div>
            </v-col>
            <v-col cols="12">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        Top 10 canais com mais publicações
                    </div>
                    <v-data-table
                        :loading="loading" loading-text="Carregando..."
                        :headers="headers_uploads"
                        :items="desserts.uploads"
                        hide-default-footer
                        v-if="desserts.uploads.length > 0"
                        >
                        <template v-slot:item.value="{ item }">
                            <span>{{formatterDecimal.format(item.value)}}</span>
                        </template>
                    </v-data-table>
                    <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                        <img src="../assets/empty/empty-cms.svg" alt="">
                        <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                        <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                            Não há dados a serem exibidos com este filtro!
                        </span>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        Top 10 canais com maiores receitas brutas
                    </div>
                    <v-data-table
                        :loading="loading" loading-text="Carregando..."
                        :headers="headers_revenue"
                        :items="desserts.revenue"
                        hide-default-footer
                        v-if="desserts.revenue.length > 0"
                        >
                        <template v-slot:item.value="{ item }">
                            <span>{{formatterMoney.format(item.value)}}</span>
                        </template>
                    </v-data-table>
                    <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                        <img src="../assets/empty/empty-cms.svg" alt="">
                        <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                        <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                            Não há dados a serem exibidos com este filtro!
                        </span>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        Top 10 canais com maiores receitas líquidas
                    </div>
                    <v-data-table
                        :loading="loading" loading-text="Carregando..."
                        :headers="headers_net_revenue"
                        :items="desserts.net_revenue"
                        hide-default-footer
                        v-if="desserts.net_revenue.length > 0"
                        >
                        <template v-slot:item.value="{ item }">
                            <span>{{formatterMoney.format(item.value)}}</span>
                        </template>
                    </v-data-table>
                    <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                        <img src="../assets/empty/empty-cms.svg" alt="">
                        <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                        <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                            Não há dados a serem exibidos com este filtro!
                        </span>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        % de visualizações
                    </div>
                    <div v-if="chartLoading.viewsItems" class="d-flex height-fluid justify-center align-center mt-12">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="mt-2 card-percentage"
                            type="PieChart"
                            :data="chartDataItems.views"
                            :options="chartOptionsPie"
                            v-if="chartDataItems.views.length > 0"
                        />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
            <v-col cols="12">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        % de inscrições
                    </div>
                    <div v-if="chartLoading.subscribersItems" class="d-flex height-fluid justify-center align-center mt-12">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="mt-2 card-percentage"
                            type="PieChart"
                            :data="chartDataItems.subscribers"
                            :options="chartOptionsPie"
                            v-if="chartDataItems.subscribers.length > 0"
                        />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
            <v-col cols="12">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        % de publicações
                    </div>
                     <div v-if="chartLoading.uploadsItems" class="d-flex height-fluid justify-center align-center mt-12">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="mt-2 card-percentage"
                            type="PieChart"
                            :data="chartDataItems.uploads"
                            :options="chartOptionsPie"
                            v-if="chartDataItems.uploads.length > 0"
                        />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
            <v-col cols="12" md="6">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        % de receitas brutas
                    </div>
                    <div v-if="chartLoading.revenueItems" class="d-flex height-fluid justify-center align-center mt-12">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="mt-2 card-percentage"
                            type="PieChart"
                            :data="chartDataItems.revenue"
                            :options="chartOptionsPie"
                            v-if="chartDataItems.revenue.length > 0"
                        />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
            <v-col cols="12" md="6">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        % de receitas líquidas
                    </div>
                    <div v-if="chartLoading.net_revenueItems" class="d-flex height-fluid justify-center align-center mt-12">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="mt-2 card-percentage"
                            type="PieChart"
                            :data="chartDataItems.net_revenue"
                            :options="chartOptionsPie"
                            v-if="chartDataItems.net_revenue.length > 0"
                        />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
        </v-row>
        <v-row v-if="hableFrequency">
            <v-col cols="12">
                <div class="d-flex justify-space-between align-center lighten-3 elevation-4 pa-4 flex-wrap">
                    <v-form ref="form" v-model="validFrequency">
                        <div class="d-flex align-center">
                            <v-select
                                v-model="frequencySelected"
                                :items="frequencys"
                                item-text="frequency"
                                item-value="value"
                                label="Periodicidade"
                                :rules="[rules.required]"
                            ></v-select>
                        </div>
                    </v-form>
                    <v-btn
                        :disabled="!validFrequency"
                        color="#1c579a"
                        class="white--text button-primary elevation-2"
                        @click="getFrequencyData"
                    >
                        <v-progress-circular v-if="loading" :indeterminate="true" size="24"></v-progress-circular>
                        <span v-else >Aplicar Filtros</span>

                    </v-btn>
                </div>
            </v-col>
            <v-col cols="12">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        Visualizações x Período
                    </div>
                    <div v-if="chartLoading.viewsLine" class="d-flex height-fluid justify-center align-center mt-12">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="card-line"
                            type="LineChart"
                            :data="chartDataItemsLine.views"
                            :options="chartOptionsLine"
                            v-if="chartDataItemsLine.views.length > 0"
                        />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
            <v-col cols="12">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        Publicações x Período
                    </div>
                    <div v-if="chartLoading.uploadsLine" class="d-flex height-fluid justify-center align-center mt-12">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="card-line"
                            type="LineChart"
                            :data="chartDataItemsLine.uploads"
                            :options="chartOptionsLine"
                            v-if="chartDataItemsLine.uploads.length > 0"
                        />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
            <v-col cols="12" md="6">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        Receita Bruta x Período
                    </div>
                    <div v-if="chartLoading.revenueLine" class="d-flex height-fluid justify-center align-center mt-12">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="card-line"
                            type="LineChart"
                            :data="chartDataItemsLine.revenue"
                            :options="chartOptionsLine"
                            v-if="chartDataItemsLine.revenue.length > 0"
                        />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
            <v-col cols="12" md="6">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        Receita Líquida x Período
                    </div>
                    <div v-if="chartLoading.net_revenueLine" class="d-flex height-fluid justify-center align-center mt-12">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="card-line"
                            type="LineChart"
                            :data="chartDataItemsLine.net_revenue"
                            :options="chartOptionsLine"
                            v-if="chartDataItemsLine.net_revenue.length > 0"
                        />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
            <v-col cols="12">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                       Total de Visualizações x Período
                    </div>
                    <div v-if="chartLoading.viewsColumn" class="d-flex height-fluid justify-center align-center mt-12">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="card-line"
                            type="ColumnChart"
                            :data="chartDataItemsColumn.views"
                            :options="chartOptionsColumn"
                            v-if="chartDataItemsColumn.views.length > 0"
                        />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
            <v-col cols="12">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        Total de Publicações x Período
                    </div>
                    <div v-if="chartLoading.uploadsColumn" class="d-flex height-fluid justify-center align-center mt-12">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="card-line"
                            type="ColumnChart"
                            :data="chartDataItemsColumn.uploads"
                            :options="chartOptionsColumn"
                            v-if="chartDataItemsColumn.uploads.length > 0"
                        />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
            <v-col cols="12">
                <div class="elevation-2 card-table">
                    <div class="body-1 grey--text text--darken-3 py-6 px-4 border">
                        Total de Receitas x Período
                    </div>
                    <div v-if="chartLoading.revenueColumn" class="d-flex height-fluid justify-center align-center mt-12">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        size="72"
                        ></v-progress-circular>
                    </div>
                    <template v-else>
                        <GChart
                            class="card-line"
                            type="ColumnChart"
                            :data="chartDataItemsColumn.revenue"
                            :options="chartOptionsColumn"
                            v-if="chartDataItemsColumn.revenue.length > 0"
                        />
                        <div v-else class="d-flex justify-center align-center pa-12 mt-4 flex-column">
                            <img src="../assets/empty/empty-cms.svg" alt="">
                            <span class="title light-blue--text text--darken-4 font-weight-bold text-center">Ops!</span>
                            <span class="body-1 grey--text text--darken-1 mt-2 text-center">
                                Não há dados a serem exibidos com este filtro!
                            </span>
                        </div>
                    </template>
                </div>
            </v-col>
        </v-row>
        <v-snackbar
            v-model="notification.active"
            :top="true"
            :color="notification.type"
            >
            {{ notification.description }}
                <v-btn
                color="white"
                text
                @click="notification.active = false"
            >
                {{ notification.closeText }}
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import { GChart } from 'vue-google-charts'
import moment from 'moment'

export default {
    components: {
        GChart
    },
    created() {  
        if (parseInt(moment().format('d')) < 4) {
            const dataIni = moment().subtract(1, 'month').calendar();
            const dataEnd = moment().subtract(3, 'days');
            this.dateIni = moment(dataIni).format('yyyy-MM-DD');
            this.dateEnd = moment(dataEnd).format('yyyy-MM-DD');
        } else {
            this.dateIni = moment().format('yyyy-MM-01');
            this.dateEnd = moment().format('yyyy-MM-DD')
        }
        this.getData();
    },
    data: () => ({
        formatterMoney: new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}),
        formatterDecimal: new Intl.NumberFormat('pt-BR', {currency: 'BRL'}),
        dateEnd: '',
        dateIni: '',
        views: '',
        uploads: '',
        subscribers: '',
        total_revenue: '',
        cms_revenue: '',
        red_revenue: '',
        yellow_revenue: '',
        green_revenue: '',
        net_total_revenue: '',
        net_red_revenue: '',
        net_yellow_revenue: '',
        net_green_revenue: '',
        activeCat: '',
        hableFrequency: false,
        notification: {
            active: false,
            description: '',
            type: '',
            closeText: ''
        },
        loading: false,
        moment: moment,
        valid: false,
        validFrequency: false,
        frequencys: [
            {value: 'day', frequency: 'Diário'},
            {value: 'week', frequency: 'Semanal'},
            {value: 'month', frequency: 'Mensal'},
            {value: 'year', frequency: 'Anual'}
        ],
        frequencySelected: '',
        headers_views: [
            { text: 'Canal', align: 'start', sortable: true, value: 'channel' },
            { text: 'Número de visualizações', align: 'end', sortable: true, value: 'value' },
        ],
        headers_subscribers: [
            { text: 'Canal', align: 'start', sortable: true, value: 'channel' },
            { text: 'Inscritos', align: 'end', sortable: true, value: 'value' },
        ],
        headers_uploads: [
            { text: 'Canal', align: 'start', sortable: true, value: 'channel' },
            { text: 'Publicações', align: 'end', sortable: true, value: 'value' },
        ],
        headers_revenue: [
            { text: 'Canal', align: 'start', sortable: true, value: 'channel' },
            { text: 'Receita Bruta', align: 'end', sortable: true, value: 'value' },
        ],
        headers_net_revenue: [
            { text: 'Canal', align: 'start', sortable: true, value: 'channel' },
            { text: 'Receita Líquida', align: 'end', sortable: true, value: 'value' },
        ],
        desserts: {
            views: [],
            uploads: [],
            revenue: [],
            net_revenue: [],
            subscribers: []
        },
        rules: {
            required: value => !!value || 'Este campo é obrigatório.'
        },
        chartDataItemsColumn: {
            views: [],
            uploads: [],
            revenue: []
        },
        chartOptionsColumn: {
            legend: { position: 'bottom'}
        },
        chartDataItemsLine: {
            views: [],
            uploads: [],
            revenue: [],
            net_revenue: []
        },
        chartOptionsLine: {
            legend: { position: 'top', maxLines: 3}
        },
        chartDataItems: {
            views: [],
            uploads: [],
            revenue: [],
            net_revenue: [],
            subscribers: []
        },
        chartLoading: {
            viewsColumn: false,
            uploadsColumn: false,
            revenueColumn: false,
            viewsLine: false,
            uploadsLine: false,
            revenueLine: false,
            viewsItems: false,
            uploadsItems: false,
            revenueItems: false,
            net_revenueItems: false,
            subscribersItems: false
        },
        chartOptionsPie: {
            pieHole: 0.5,
            chartArea: {width:'90%',height:'300'},
            legend: {position: 'center'},
        }
    }),
    methods: {
        bloqCalendar(event) {
            event.preventDefault();
            return false;
        },
        getData() {
            this.loading = true;
            this.hableFrequency = false;
            this.getAnalyticsCards();
            this.getTopChannels('views');
            this.getTopChannels('uploads');
            this.getTopChannels('revenue');
            this.getTopChannels('net_revenue');
            this.getTopChannels('subscribers');
            this.getPercentageChannels('views');
            this.getPercentageChannels('uploads');
            this.getPercentageChannels('revenue');
            this.getPercentageChannels('net_revenue');
            this.getPercentageChannels('subscribers');
            this.hableFrequency = true;
            this.loading = false;
            this.chartLoading.viewsItems = true;
            this.chartLoading.uploadsItems = true;
            this.chartLoading.revenueItems = true;
            this.chartLoading.net_revenueItems = true;
            this.chartLoading.subscribersItems = true;
        },
        getFrequencyData() {
            this.loading = true;
            this.getMetricsChannels('views');
            this.getMetricsChannels('uploads');
            this.getMetricsChannels('revenue');
            this.getMetricsChannels('net_revenue');
            this.getTotals('views');
            this.getTotals('uploads');
            this.getTotals('revenue');
            this.chartLoading.viewsColumn = true;
            this.chartLoading.uploadsColumn = true;
            this.chartLoading.revenueColumn = true;
            this.chartLoading.viewsLine = true;
            this.chartLoading.uploadsLine = true;
            this.chartLoading.revenueLine = true;
            this.loading = false;
        },
        getAnalyticsCards() {
            this.$http.get( '/analytics/global/cards?start_date=' + this.dateIni +'&end_date=' + this.dateEnd )
            .then( ( res ) => {
                this.views = res.data.views;
                this.uploads = res.data.uploads;
                this.subscribers = res.data.subscribers;
                this.cms_revenue = res.data.cms_revenue;
                this.total_revenue = res.data.total_revenue;
                this.red_revenue = res.data.red_revenue;
                this.yellow_revenue = res.data.yellow_revenue;
                this.green_revenue = res.data.green_revenue;
                this.net_total_revenue = res.data.net_total_revenue;
                this.net_red_revenue = res.data.net_red_revenue;
                this.net_yellow_revenue = res.data.net_yellow_revenue;
                this.net_green_revenue = res.data.net_green_revenue;
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro ao buscar os dados, tente uma nova data.',
                    type: 'error',
                    closeText: 'Fechar'
                }
            })
        },
        getTopChannels(param) {
            this.$http.get( '/analytics/global/top-channels?metric=' + param + '&start_date=' + this.dateIni +'&end_date=' + this.dateEnd )
            .then( ( res ) => {
                switch (param) {
                    case "views":
                        this.desserts.views = res.data
                        break;
                    case "subscribers":
                        this.desserts.subscribers = res.data
                        break;
                    case "revenue":
                        this.desserts.revenue = res.data
                        break;
                    case "net_revenue":
                        this.desserts.net_revenue = res.data
                        break;
                    case "uploads":
                        this.desserts.uploads = res.data
                        break;
                }
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro ao buscar os dados, tente uma nova data.',
                    type: 'error',
                    closeText: 'Fechar'
                }
            })
        },
        getPercentageChannels(param) {
            this.$http.get( '/analytics/global/channels-percentage?metric=' + param + '&start_date=' + this.dateIni +'&end_date=' + this.dateEnd )
            .then( ( res ) => {
                const helper = [res.data.columns];
                let arr = helper.concat(res.data.rows);
                if (arr.length > 1) {
                    switch (param) {
                        case "views":
                            this.chartDataItems.views = arr;
                            this.chartLoading.viewsItems = false;
                            break;
                        case "subscribers":
                            this.chartDataItems.subscribers = arr;
                            this.chartLoading.subscribersItems = false;
                            break;
                        case "revenue":
                            this.chartDataItems.revenue = arr;
                            this.chartLoading.revenueItems = false;
                            break;
                        case "net_revenue":
                            this.chartDataItems.net_revenue = arr;
                            this.chartLoading.net_revenueItems = false;
                            break;
                        case "uploads":
                            this.chartDataItems.uploads = arr;
                            this.chartLoading.uploadsItems = false;
                            break;
                    }
                } else {
                    this.chartLoading.viewsItems = false;
                    this.chartLoading.subscribersItems = false;
                    this.chartLoading.revenueItems = false;
                    this.chartLoading.net_revenueItems = false;
                    this.chartLoading.uploadsItems = false;
                }
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro ao buscar os dados, tente uma nova data.',
                    type: 'error',
                    closeText: 'Fechar'
                }
            })
        },
        getMetricsChannels(param) {
            this.$http.get( '/analytics/global/channel-metrics?metric=' + param + '&aggregation='+ this.frequencySelected +'&start_date=' + this.dateIni +'&end_date=' + this.dateEnd )
            .then( ( res ) => {
                const helper = [res.data.columns];
                let arr = helper.concat(res.data.rows);
                if (arr.length > 1) {
                    switch (param) {
                        case "views":
                            this.chartDataItemsLine.views = arr;
                            this.chartLoading.viewsLine = false;
                            break;
                        case "revenue":
                            this.chartDataItemsLine.revenue = arr;
                            this.chartLoading.revenueLine = false;
                            break;
                        case "net_revenue":
                            this.chartDataItemsLine.net_revenue = arr;
                            this.chartLoading.net_revenueLine = false;
                            break;
                        case "uploads":
                            this.chartDataItemsLine.uploads = arr;
                            this.chartLoading.uploadsLine = false;
                            break;
                    }
                } else {
                    this.chartLoading.viewsLine = false;
                    this.chartLoading.revenueLine = false;
                    this.chartLoading.net_revenueLine = false;
                    this.chartLoading.uploadsLine = false;
                }
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro ao buscar os dados, tente uma nova data.',
                    type: 'error',
                    closeText: 'Fechar'
                }
            })
        },
        getTotals(param) {
            this.$http.get( '/analytics/global/totals?metric=' + param + '&aggregation='+ this.frequencySelected +'&start_date=' + this.dateIni +'&end_date=' + this.dateEnd )
            .then( ( res ) => {
                const helper = [res.data.columns];
                let arr = helper.concat(res.data.rows);
                if (arr.length > 1) {
                    switch (param) {
                        case "views":
                            this.chartDataItemsColumn.views = arr;
                            this.chartLoading.viewsColumn = false;
                            break;
                        case "revenue":
                            this.chartDataItemsColumn.revenue = arr;
                            this.chartLoading.revenueColumn = false;
                            break;
                        case "uploads":
                            this.chartDataItemsColumn.uploads = arr;
                            this.chartLoading.uploadsColumn = false;
                            break;
                    }
                } else {
                    this.chartLoading.viewsColumn = false;
                    this.chartLoading.revenueColumn = false;
                    this.chartLoading.uploadsColumn = false;
                }
            } ).catch( () => {
                this.notification = {
                    active: true,
                    description: 'Houve um erro ao buscar os dados, tente uma nova data.',
                    type: 'error',
                    closeText: 'Fechar'
                }
            })
        }
    }
}
</script>

<style lang="scss">
    .size-date {
        width: 275px;
    }
    .border {
        border-bottom: 1px solid #f3f3f3;
    }
    .card-table {
        min-height: 400px;
    }
    .card-percentage {
        height: 400px;
    }
    .card-line {
        height: 400px;
    }
    .cat-btn.active {
        border: 1px solid#ececec;
        background-color: rgb(240, 240, 240);
        border-radius: 50%;
        padding: 2px;
    }
    .cat-btn:hover {
        background-color: rgb(240, 240, 240);
        border-radius: 50%;
        padding: 2px;
    }
</style>